<template>
  <div class="container">
    <div class="row">
        <div class="col-12 c">
            <div class="card card-body">
                <div class="row">
                    <div class="col-12 col-lg-7">
                        <h2>
                            كيف ابدأ؟
                        </h2>
                        <hr>
                        <h3>
                            <ol id="cc">
                                <li>
                                    قم بإضافة الفصول.
                                </li>
                                <li>
                                    قم بإضافة المواد وتعيين نصاب كل مادة.
                                </li>
                                <li>
                                    قم بإضافة المعلمين واسناد المواد لهم.
                                </li>
                                <li>
                                    قم بإنشاء جدول جديد.
                                </li>
                            </ol>
                        </h3>
                        <div class="col-12 text-center">
                            <a href="javascript:;" class="btn btn-lg btn-outline-primary text-primary" style="border-radius: 20px">
                                <i class="fa fa-youtube"></i>
                                شاهد الشرح المرئي
                            </a>
                        </div>
                        <br><br>
                        <i class="fa fa-info-circle"></i>
                        نظام <strong>المُنجز</strong> التابع لنظام <strong>التحضير الذكي</strong>.
                    </div>
                    <div class="col-12 col-lg-5 d-none d-lg-block">
                        <img :src="require('@/assets/images/hero.png')" style="width: 100%; max-width: 355px">
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
#cc li{
    padding: 10px;
}
</style>